<template>
  <BaseDataIterator ref="dataList" :service="fetchContacts">
    <template #default="{ data }">
      <BaseDataTable :data="data">
        <template #header>
          <ContactListHeader />
        </template>

        <template #default="{ item }">
          <ContactListItem :contact="item" @select="handleContactSelect" />
        </template>
      </BaseDataTable>
    </template>
  </BaseDataIterator>
</template>

<script>
import { accountPossibleDuplicateContactsClient } from '@/api/clients';
import ContactListHeader from './ContactListHeader.vue';
import ContactListItem from './ContactListItem.vue';
export default {
  components: {
    ContactListHeader,
    ContactListItem,
  },
  props: {
    accountId: {
      type: String,
      required: true,
    },
  },
  methods: {
    fetchContacts(params = {}) {
      return accountPossibleDuplicateContactsClient.list(this.accountId, {
        ...params,
      });
    },
    handleContactSelect(contact) {
      this.$emit('select', contact);
    },
  },
};
</script>
